import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {competencyById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {teamsVolumesSummaryByIdByCompetency} from '/redux/selector/metric.teams.selector';
import {withProps} from '/util/selector.util';

import TeamsVolumeSummaryCard from './TeamsVolumeSummaryCard';

const getCompetencyByUserId = withProps({coachId: userId})(competencyById);

export default connect(
  createStructuredSelector({
    currentUserCompetency: getCompetencyByUserId,
    metrics: withProps({
      coachId: userId,
      competency: getCompetencyByUserId,
    })(teamsVolumesSummaryByIdByCompetency),
  }),
)(TeamsVolumeSummaryCard);
